import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import Tabs from "../../Components/Tabs";
import AdminHeader from "../Admin/Components/AdminHeader";
import AdminSidebar from "./Components/MenuSidebar";

import PaidBookingList from "./Components/BookingList/PaidBookingList";
import CollectedBookingList from "./Components/BookingList/CollectedBookingList";
import BookingRequestList from "./Components/BookingList/BookingRequests";
import BookingHistoryList from "./Components/BookingList/BookingHistoryList";
import PanelWrapper from "./PanelWrapper";

const MessagesPage = () => {
  const tabs = ["Spent", "Earned", "Requests", "History"];

  const [selectedList, setSelectedList] = useState("Spent");
  const [searchText, setSearchText] = useState("");

  return (
    <PanelWrapper>
      <div className="container">
        <div className="page-header">
          <h2>Bookings</h2>
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of bookings</h3>

            {/* <div className="filter-area">
                  <div className="form-group">
                    <div className="with-icon">
                      <FontAwesomeIcon icon={faSearch} />
                      <input
                        type="text"
                        className="form-control"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>
                </div> */}
          </div>

          <Tabs
            type="Small Tabs"
            tabs={tabs}
            selected={selectedList}
            setSelected={(tab: string) => setSelectedList(tab)}
          />

          {selectedList === "Spent" && <PaidBookingList search={searchText} />}
          {selectedList === "Earned" && (
            <CollectedBookingList search={searchText} />
          )}
          {selectedList === "Requests" && (
            <BookingRequestList search={searchText} />
          )}
          {selectedList === "History" && (
            <BookingHistoryList search={searchText} />
          )}
        </div>
      </div>
    </PanelWrapper>
  );
};

export default MessagesPage;
